export const BreakpointValues = {
  sm: 0,
  md: 600,
  lg: 1024,
  lgPlus: 1250,
  xl: 1400,
}

export default {
  sm: BreakpointValues.sm + "px",
  md: BreakpointValues.md + "px",
  lg: BreakpointValues.lg + "px",
  lgPlus: BreakpointValues.lgPlus + "px",
  xl: BreakpointValues.xl + "px",
}
